/**
 * 统一的错误码常量 (SSOT)
 *
 * 合并了原 ERROR_CODES 和 AUTH_ERROR_CODES
 */
export const ERROR_CODES = {
  // 认证错误 (401)
  UNAUTHENTICATED: "UNAUTHENTICATED",
  INVALID_TOKEN: "INVALID_TOKEN",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  // 授权错误 (403)
  FORBIDDEN: "FORBIDDEN",
  INSUFFICIENT_PERMISSIONS: "INSUFFICIENT_PERMISSIONS",
  ACCOUNT_DISABLED: "ACCOUNT_DISABLED",
  INVALID_ROLE: "INVALID_ROLE",
  MISSING_STAFF_ID: "MISSING_STAFF_ID",

  // 验证错误 (400)
  VALIDATION_ERROR: "VALIDATION_ERROR",
  INVALID_INPUT: "INVALID_INPUT",
  MISSING_REQUIRED_FIELD: "MISSING_REQUIRED_FIELD",

  // 资源错误 (404)
  NOT_FOUND: "NOT_FOUND",
  RESOURCE_NOT_FOUND: "RESOURCE_NOT_FOUND",

  // 服务器错误 (500)
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  DATABASE_ERROR: "DATABASE_ERROR",
  EXTERNAL_SERVICE_ERROR: "EXTERNAL_SERVICE_ERROR",

  // 业务逻辑错误 (422)
  BUSINESS_RULE_VIOLATION: "BUSINESS_RULE_VIOLATION",
  DUPLICATE_RESOURCE: "DUPLICATE_RESOURCE",
  INVALID_STATE_TRANSITION: "INVALID_STATE_TRANSITION",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
